import React from "react";
import { getAppName } from "../../utils/appConfig";

// Logo image file, uploaded under REACT_APP_STYLES_PATH (/assets/images/).
// encodeURIComponent keeps the space in the file name valid in the URL.
export const LOGO_FILE = "rupyybox-PAYMENT.png";
export const LOGO_SRC = `${process.env.REACT_APP_STYLES_PATH}${encodeURIComponent(
  LOGO_FILE
)}`;

// Renders the brand from a single place:
//   <AppBrand />        -> logo image (pic, default)
//   <AppBrand text />   -> app name as text (via getAppName())
// Pass className / style through for per-usage sizing (same as the old <img>).
const AppBrand = ({ className = "", style, text = false }) => {
  const cls = `app-brand ${className}`.trim();

  if (text) {
    return (
      <span className={cls} style={style}>
        {getAppName()}
      </span>
    );
  }

  return <img src={LOGO_SRC} alt={getAppName()} className={cls} style={style} />;
};

export default AppBrand;
